import type { MessageKey } from '../en';

export const zh: Partial<Record<MessageKey, string>> = {
  "defaults.accuracy.desc": "用于新历史点的精度",
  "defaults.accuracy.title": "默认 GPS 精度",
  "defaults.actual.desc": "模拟期间用于搜索地点",
  "defaults.actual.empty": "尚未保存",
  "defaults.actual.emptyHint": "允许定位，并在不模拟时打开应用以捕获位置。",
  "defaults.actual.pending": "手机会保存此位置。同步尚未连接。",
  "defaults.actual.refresh": "立即更新",
  "defaults.actual.title": "你的真实位置",
  "defaults.browserChip": "此浏览器",
  "defaults.close": "关闭",
  "defaults.color.desc": "新路线的线条颜色",
  "defaults.color.group": "路线颜色",
  "defaults.color.title": "路线颜色",
  "defaults.degrees": "{n}°",
  "defaults.format.dayMonthYear": "日期、年份 · 12 小时",
  "defaults.format.dayShort": "星期和日期 · 12 小时",
  "defaults.format.eu": "欧盟日期 · 24 小时",
  "defaults.format.fullDay": "完整日期 · 12 小时",
  "defaults.format.iso": "ISO 日期 · 24 小时",
  "defaults.format.monthFirst": "月份在前 · 24 小时",
  "defaults.format.shortDayYear": "星期、日期、年份 · 24 小时",
  "defaults.format.timeFirst": "时间在前 · 24 小时",
  "defaults.format.us": "美国日期 · 12 小时",
  "defaults.format.withSeconds": "含秒 · 12 小时",
  "defaults.itinAccuracy.desc": "新路段的 GPS 精度",
  "defaults.itinAccuracy.title": "精度",
  "defaults.itinerary.desc": "新路段的默认值",
  "defaults.itinerary.title": "路线",
  "defaults.joyAccuracy.desc": "创建摇杆会话时的起始 GPS 精度",
  "defaults.joyAccuracy.title": "默认 GPS 精度",
  "defaults.joyName.desc": "新摇杆会话的默认名称",
  "defaults.joyName.dialogTitle": "选择会话名称格式",
  "defaults.joyName.title": "日期格式",
  "defaults.joySpeed.desc": "创建摇杆会话时的起始速度",
  "defaults.joySpeed.title": "默认速度",
  "defaults.joyUnit.desc": "以 km/h 或 mph 显示并调整摇杆速度",
  "defaults.joystick.desc": "摇杆会话的默认值",
  "defaults.joystick.title": "摇杆",
  "defaults.kilometers": "{n} 公里",
  "defaults.map.desc": "新地图如何打开",
  "defaults.map.title": "Google Map",
  "defaults.mapTheme.desc": "新地图屏幕的外观",
  "defaults.mapTheme.group": "地图主题",
  "defaults.mapTheme.title": "地图主题",
  "defaults.marker.car": "汽车",
  "defaults.marker.desc": "创建摇杆会话时使用。可以按会话更改。",
  "defaults.marker.group": "默认标记",
  "defaults.marker.maps": "Maps",
  "defaults.marker.title": "默认标记",
  "defaults.marker.waze": "Waze",
  "defaults.meters": "{n} 米",
  "defaults.nameFormat.desc": "固定点的默认名称",
  "defaults.nameFormat.dialogSubtitle": "预览使用今天的日期。为新点选择紧凑格式。",
  "defaults.nameFormat.dialogTitle": "选择点名称格式",
  "defaults.nameFormat.group": "日期格式",
  "defaults.nameFormat.title": "日期格式",
  "defaults.overlay.itinerary.desc": "路线模拟在后台继续时的悬浮播放器",
  "defaults.overlay.itinerary.title": "自动路线",
  "defaults.overlay.joystick.desc": "会话在后台继续时的悬浮摇杆",
  "defaults.overlay.joystick.title": "摇杆",
  "defaults.overlay.playlist.desc": "列表模拟在后台继续时的悬浮播放器",
  "defaults.overlay.playlist.title": "列表",
  "defaults.overlay.stationary.desc": "固定模拟在后台继续时的悬浮播放器",
  "defaults.overlay.stationary.title": "固定点",
  "defaults.plAccuracy.desc": "应用到每个列表图钉的 GPS 精度",
  "defaults.plAccuracy.title": "每项精度",
  "defaults.player.desc": "悬浮播放器和模拟控件",
  "defaults.player.title": "播放器",
  "defaults.playlist.desc": "新列表图钉的默认值",
  "defaults.playlist.title": "列表",
  "defaults.polyline.desc": "摇杆会话期间绘制路线的默认颜色。",
  "defaults.polyline.group": "折线颜色",
  "defaults.polyline.title": "默认折线颜色",
  "defaults.range.accuracyMax": "300 米",
  "defaults.range.accuracyMin": "0 米",
  "defaults.range.itinAccuracyMax": "100",
  "defaults.range.itinAccuracyMin": "1",
  "defaults.range.joyAccuracyMax": "100 米",
  "defaults.range.joyAccuracyMin": "1 米",
  "defaults.range.plAccuracyMax": "500 米",
  "defaults.range.plAccuracyMin": "0 米",
  "defaults.range.searchMax": "50 公里",
  "defaults.range.searchMin": "3 公里",
  "defaults.range.tiltMax": "65°",
  "defaults.range.tiltMin": "0°",
  "defaults.range.timeMax": "600 秒",
  "defaults.range.timeMin": "0 秒",
  "defaults.range.zoomMax": "20",
  "defaults.range.zoomMin": "10",
  "defaults.reset": "重置",
  "defaults.search.itinerary": "优先显示地图中心附近的结果",
  "defaults.search.playlist": "优先显示地图中心附近的结果",
  "defaults.search.stationary": "优先显示图钉附近的结果",
  "defaults.search.title": "搜索半径",
  "defaults.seconds": "{n} 秒",
  "defaults.section.appearance": "外观",
  "defaults.section.camera": "相机",
  "defaults.section.history": "历史",
  "defaults.section.location": "位置背景",
  "defaults.section.map": "地图",
  "defaults.section.motion": "运动",
  "defaults.section.overlay": "悬浮播放器",
  "defaults.section.playlist": "列表",
  "defaults.section.search": "搜索",
  "defaults.section.style": "样式",
  "defaults.section.view": "地图",
  "defaults.sectionDefaults": "应用默认值",
  "defaults.sectionDefaultsDesc": "设置默认值，让体验更快、更顺畅",
  "defaults.sectionPlayer": "播放器",
  "defaults.sectionPlayerDesc": "悬浮层和播放设置",
  "defaults.speed.desc": "新路段的播放速度",
  "defaults.speed.title": "默认速度",
  "defaults.speedValue": "{n} {unit}",
  "defaults.stationary.desc": "新地图点的默认值",
  "defaults.stationary.title": "固定点",
  "defaults.summary.playerAll": "全部悬浮层已开启",
  "defaults.summary.playerOff": "悬浮层已关闭",
  "defaults.summary.playerSome": "4 项中 {on} 项已开启",
  "defaults.summary.zoom": "缩放 {n}",
  "defaults.syncNote": "目前保存在此浏览器中。同步连接后，手机应用将使用这些值。",
  "defaults.theme.night": "夜间",
  "defaults.theme.nightDesc": "适合弱光和夜间会话的深色地图。",
  "defaults.theme.retro": "复古",
  "defaults.theme.retroDesc": "温暖的复古色调，带有经典地图的感觉。",
  "defaults.theme.silver": "银色",
  "defaults.theme.silverDesc": "浅灰色风格，白天看着舒服。",
  "defaults.theme.standard": "标准",
  "defaults.theme.standardDesc": "经典 Google 地图颜色，熟悉的绿色和蓝色。",
  "defaults.tilt.desc": "地图屏幕上的相机角度",
  "defaults.tilt.title": "默认相机倾斜",
  "defaults.time.desc": "移到下一个图钉前的等待",
  "defaults.time.title": "每项时间",
  "defaults.tray.group": "托盘高度",
  "defaults.tray.large": "大",
  "defaults.tray.medium": "中",
  "defaults.tray.playlistDesc": "地图上可见的列表面板",
  "defaults.tray.small": "小",
  "defaults.tray.stationaryDesc": "地图上可见面板的大小",
  "defaults.tray.title": "托盘高度",
  "defaults.unit.group": "速度单位",
  "defaults.unit.itineraryDesc": "在路线模块中以 km/h 或 mph 显示速度",
  "defaults.unit.kmh": "km/h",
  "defaults.unit.mph": "mph",
  "defaults.unit.title": "速度单位",
  "defaults.view.grid": "网格",
  "defaults.view.group": "视图",
  "defaults.view.historyDesc": "已保存的点如何显示",
  "defaults.view.historyTitle": "历史视图",
  "defaults.view.list": "列表",
  "defaults.view.playlistDesc": "已保存的列表如何显示",
  "defaults.view.playlistTitle": "列表视图",
  "defaults.zoom.desc": "新地图的起始缩放",
  "defaults.zoom.title": "默认缩放级别",
  "language.defaultBadge": "默认",
  "language.empty": "没有语言符合此搜索。",
  "language.lead": "英语（美国）是默认语言。你的选择保存在此浏览器中。",
  "language.listLabel": "语言",
  "language.preview": "模拟位置、列表和路线。",
  "language.previewLabel": "预览",
  "language.searchLabel": "搜索语言",
  "language.searchPlaceholder": "搜索语言",
  "nav.account": "账户",
  "nav.account.desc": "资料、Premium 和登录。",
  "nav.analytics": "分析",
  "nav.analytics.desc": "了解 MockLoc 活动、网络使用和同步状态。",
  "nav.articles": "文章",
  "nav.articles.desc": "设置、播放和同步指南。",
  "nav.backup": "备份与同步",
  "nav.backup.desc": "云备份和同步的状态。",
  "nav.coins": "Mock Coins",
  "nav.coins.desc": "按模块和活动列出的金币使用明细。",
  "nav.dashboard": "概览",
  "nav.dashboard.desc": "位置、列表、路线和账户活动的概览。",
  "nav.devices": "管理设备",
  "nav.devices.desc": "查看已登录 MockLoc 账户的设备。",
  "nav.help": "帮助与支持",
  "nav.help.desc": "跟踪对话并向 MockLoc 团队求助。",
  "nav.history": "位置历史",
  "nav.history.desc": "此账户模拟过的地点。",
  "nav.itinerary": "路线",
  "nav.itinerary.desc": "创建、编辑并管理已保存的路线。",
  "nav.joystick": "摇杆会话",
  "nav.joystick.desc": "播放路线、统计和已保存的摇杆会话。",
  "nav.notifications": "通知",
  "nav.notifications.desc": "同步、备份和产品通知。",
  "nav.playlist": "列表",
  "nav.playlist.desc": "有序的模拟位置集合。",
  "nav.settings": "设置",
  "nav.settings.desc": "主题、语言和移动应用默认值。",
  "nav.stationary": "固定点",
  "nav.stationary.desc": "保存在此账户上的固定模拟位置。",
  "nav.whatsNew": "应用新功能",
  "nav.whatsNew.desc": "MockLoc 的新更新、修复和改进。",
  "settings.back": "设置",
  "settings.backDefaults": "应用默认值",
  "settings.defaults.shellDesc": "手机应用用于地图、点、路线和播放的值。",
  "settings.defaults.shellTitle": "应用默认值",
  "settings.home.defaults.desc": "手机应用的地图、点、列表、路线、摇杆和播放器默认值。",
  "settings.home.defaults.title": "移动应用默认值",
  "settings.home.language.desc": "选择菜单、页面标题和设置的语言。",
  "settings.home.language.title": "语言设置",
  "settings.home.theme.desc": "此浏览器的文字大小、颜色、浅色或深色以及字体。",
  "settings.home.theme.title": "主题设置",
  "settings.language.shellDesc": "选择此网站的语言。",
  "settings.language.shellTitle": "语言",
  "settings.theme.shellDesc": "此浏览器的文字大小、颜色、浅色或深色以及字体。",
  "settings.theme.shellTitle": "主题",
  "shell.account": "账户",
  "shell.accountMenu": "账户菜单",
  "shell.accountMenuNamed": "账户菜单，{name}",
  "shell.closeMenu": "关闭菜单",
  "shell.collapseSidebar": "收起侧边栏",
  "shell.dashboardSubtitle": "在一处管理模拟位置、列表、路线等。",
  "shell.devicesLimit": "最多在 3 台设备上使用",
  "shell.expandSidebar": "展开侧边栏",
  "shell.goPremium": "升级 Premium",
  "shell.logOut": "退出登录",
  "shell.mainNav": "主导航",
  "shell.noMatches": "没有匹配项",
  "shell.notifications": "通知",
  "shell.notificationsUnread": "通知，{count} 条未读",
  "shell.openMenu": "打开菜单",
  "shell.pages": "页面",
  "shell.recent": "最近",
  "shell.searchLabel": "搜索位置、列表、路线、文章",
  "shell.searchPlaceholder": "搜索位置、列表、路线、文章...",
  "shell.searchResults": "搜索结果",
  "shell.tagline": "模拟位置，简单完成",
  "shell.themeDarkTitle": "深色主题",
  "shell.themeLightTitle": "浅色主题",
  "shell.themeToDark": "切换到深色主题",
  "shell.themeToLight": "切换到浅色主题",
  "shell.there": "你",
  "shell.unlimitedCoins": "无限金币",
  "shell.unlimitedEverything": "全部无限",
  "shell.upgradeNow": "立即升级",
  "shell.viewAllNotifications": "查看全部通知",
  "shell.welcome": "欢迎回来，{name}！",
  "theme.builtin": "内置",
  "theme.changesLabel": "会改变什么。",
  "theme.color.accent.changes": "品牌金和浅金背景，包括插图的小细节。",
  "theme.color.accent.title": "强调色",
  "theme.color.accent.where": "登录、文章和徽章上的金色高亮。",
  "theme.color.danger.changes": "红色错误文字和破坏性操作。",
  "theme.color.danger.title": "危险",
  "theme.color.danger.where": "错误、删除和未读圆点。",
  "theme.color.info.changes": "浅色和深色中用于信息的蓝色。",
  "theme.color.info.title": "信息",
  "theme.color.info.where": "蓝色状态、信息链接和信息标记。",
  "theme.color.lead": "内置颜色在浅色和深色中保持不同，直到你选择一种。你的选择用于两种主题。保存在点、列表或路线上的颜色保持不变。",
  "theme.color.primary.changes": "实心紫、浅紫文字和柔和的紫色背景。",
  "theme.color.primary.title": "主色",
  "theme.color.primary.where": "按钮、当前菜单项、链接和品牌紫色。",
  "theme.color.success.changes": "绿色状态文字和成功标记。",
  "theme.color.success.title": "成功",
  "theme.color.success.where": "已同步、已完成和正向状态。",
  "theme.color.title": "颜色",
  "theme.color.warning.changes": "琥珀色警告和金币使用的金色。",
  "theme.color.warning.title": "警告",
  "theme.color.warning.where": "提醒、金币标记和 Premium 高亮。",
  "theme.colorAria": "颜色 {title}",
  "theme.custom": "自定义",
  "theme.face.arialBold": "Arial Bold",
  "theme.face.arialRegular": "Arial Regular",
  "theme.face.arialSynth": "由 Arial 合成",
  "theme.face.gsBold": "Google Sans Bold",
  "theme.face.gsRegular": "Google Sans Regular",
  "theme.face.helveticaOther": "Helvetica 或合成",
  "theme.face.helveticaRegular": "Helvetica Regular",
  "theme.face.inter": "Inter {weight}",
  "theme.font.arial.note": "Regular 和 Bold 是已安装字体。其他字重由系统合成。",
  "theme.font.google-sans.note": "Regular 文件覆盖 400 和 500。Bold 文件覆盖 600 到 900。",
  "theme.font.group": "字体",
  "theme.font.helvetica.note": "在此设备上使用 Helvetica，然后是 Helvetica Neue，然后是 Arial。",
  "theme.font.inter.note": "网站今天使用的字体。已加载 Regular 到 Black。",
  "theme.font.lead": "整个网站使用一种字体。选择 Inter 时，营销标题会回到 Plus Jakarta Sans。下面的字重是界面已经在用的。",
  "theme.font.sample": "模拟位置，简单完成",
  "theme.font.title": "字体",
  "theme.hexAria": "十六进制 {title}",
  "theme.lead": "为此浏览器选择文字大小、颜色、浅色或深色以及字体。100% 等于今天的屏幕。这里的示例和网站其余部分一起更新。",
  "theme.manager": "主题管理",
  "theme.mode.dark": "深色",
  "theme.mode.darkHint": "深色表面和浅色文字。",
  "theme.mode.group": "主题",
  "theme.mode.lead": "与顶栏按钮相同的浅色或深色选择。",
  "theme.mode.light": "浅色",
  "theme.mode.lightHint": "浅色表面和深色文字。",
  "theme.mode.title": "主题",
  "theme.previewBody": "保存在此账户上的位置。",
  "theme.previewBold": "列表已就绪",
  "theme.previewHelp": "有序的模拟位置集合。",
  "theme.previewKicker": "实时预览",
  "theme.previewTitle": "模拟位置",
  "theme.reset": "重置",
  "theme.resetAll": "全部重置",
  "theme.resetColors": "重置颜色",
  "theme.resetFont": "重置字体",
  "theme.resetText": "重置文字",
  "theme.sizeAria": "{title} 的大小",
  "theme.text.bold.changes": "15 px 到 18 px 的文字。",
  "theme.text.bold.sample": "升级 Premium",
  "theme.text.bold.title": "粗体",
  "theme.text.bold.where": "卡片标题、品牌名、分区标题和大按钮。",
  "theme.text.descriptive.changes": "12 px 到 13 px 的文字。",
  "theme.text.descriptive.sample": "有序的模拟位置集合。",
  "theme.text.descriptive.title": "说明",
  "theme.text.descriptive.where": "副标题、帮助文字、徽章、页脚和次要行。",
  "theme.text.header.changes": "20 px 及以上的文字。",
  "theme.text.header.sample": "固定点",
  "theme.text.header.title": "标题",
  "theme.text.header.where": "页面标题、大标题、空状态标题，以及金币余额等大数字。",
  "theme.text.lead": "每种角色共用一个大小。示例显示该角色。此页的滑块保持固定大小，便于操作。",
  "theme.text.normal.changes": "14 px 的文字。",
  "theme.text.normal.sample": "保存在此账户上的位置。",
  "theme.text.normal.title": "常规",
  "theme.text.normal.where": "导航标签、标准按钮、列表标题和简短摘要。",
  "theme.text.other.changes": "9 px 到 11 px 的文字。小于 9 px 的标记保持固定。",
  "theme.text.other.sample": "2 小时前更新",
  "theme.text.other.title": "其他",
  "theme.text.other.where": "小标签、时间戳、图表标签和说明文字。",
  "theme.text.title": "文字",
  "theme.weight.black": "Black",
  "theme.weight.bold": "Bold",
  "theme.weight.extrabold": "Extra bold",
  "theme.weight.medium": "Medium",
  "theme.weight.regular": "Regular",
  "theme.weight.sample": "模拟位置、列表和路线",
  "theme.weight.semibold": "Semibold",
  "theme.whereLabel": "用在哪里。",
};
